import React, { useCallback, useEffect, useState } from 'react'
import { Template } from '../../Components/Template/template'
import {
    AlertType, GradeProduto, ItensVendas, KEY_CODE_ENTER, classBorderLabelDark, classDivBackground, classDivBody,
    classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, classbtColunasAzul
} from '../../Utils/Types'
import { IoCreate } from 'react-icons/io5'
import { ModalBuscaProduto } from '../../Components/Modal/modal-busca-produto'
import { VendasService } from './vendasService'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { Funcoes } from '../../Utils/Funcoes'
import { ModalCancelVendaItem } from '../../Components/Modal/modal-cancelItemVenda'
import { ModalDesconto } from '../../Components/Modal/modal-venda-desconto'
import { ModalIdentificarCliente } from '../../Components/Modal/modal-identificar-cliente'
import { ModalCancelarIdentificacao } from '../../Components/Modal/modal-cancelIdentificacao'
import { ModalFecharVenda } from '../../Components/Modal/modal-fechar-venda'
import { MdOutlinePersonOff, MdPersonSearch, MdPointOfSale } from 'react-icons/md'
import { TbPackageOff, TbShoppingCartOff } from 'react-icons/tb'
import { LuPackageSearch } from 'react-icons/lu'
import { ModalAbrirGradeVenda } from '../../Components/Modal/modal-abrir-grade-venda'
import { Tooltip } from 'react-tooltip'
import { ModalExcluirDados } from '../../Components/Modal/ModalExcluirDados'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUser } from '../../Components/Redux/userSlice'
import { ProdutoService } from '../Products/ProdutoService'
import { RiEdit2Fill } from 'react-icons/ri'
import { FaTrashAlt } from 'react-icons/fa'
import { ModalEditItemVenda } from '../../Components/Modal/modal-edit-item-venda'


export const LancaVendas = React.memo(() => {

    const { idDaVenda } = useParams<string>()

    const [visibleBuscarProd, setVisibleBuscarProd] = useState(false)
    const [visibleDesconto, setVisibleDesconto] = useState(false)
    const [visibleCancelItemVenda, setVisibleCancelItemVenda] = useState(false)
    const [visibleCancelVenda, setVisibleCancelVenda] = useState(false)
    const [visibleIdentificarCli, setVisibleIdentificarCli] = useState(false)
    const [visibleCancelIdentifcacao, setVisibleCancelIdentifcacao] = useState(false)
    const [visible_Modal_Fechar_Venda, setVisible_Modal_Fechar_Venda] = useState(false)
    const [visible_Modal_Config_Impressao, setVisible_Modal_Config_Impressao] = useState(false)
    const [visible_Modal_Edit_Item_Venda, setVisible_Modal_Edit_Item_Venda] = useState(false)
    const [idGrade, setIdGrade] = useState(0)

    const [loadingDesconto, setLoadingDesconto] = useState(false)
    const [loadingCancelItemVenda, setLoadingCancelItemVenda] = useState(false)
    const [loadingCancelVenda, setLoadingCancelVenda] = useState(false)
    const [loadingIdentifcarCli, setLoadingIdentificarCli] = useState(false)
    const [loadingCancelIdentifcacao, setLoadingCancelIdentifcacao] = useState(false)
    const [loading_Modal_Fechar_Venda, setLoading_Modal_Fechar_Venda] = useState(false)
    const [loading_Modal_Config_Impressao, setLoading_Modal_Config_Impressao] = useState(false)

    const [visibleMsg, setVisibleMsg] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    const [totalItens, setTotalItens] = useState(0)
    const [subTotal, setSubTotal] = useState(Funcoes.numberFormat(0, "currency"))
    const [subTotalCopy, setSubTotalCopy] = useState(Funcoes.numberFormat(0, "currency"))
    const [desconto, setDesconto] = useState("")

    const [prodVendas, setProdVendas] = useState<any[]>([])
    const [dadosCliente, setDadosCliente] = useState([])

    const [idVenda, setIdVenda] = useState(0)
    const [numItem, setNumItem] = useState(0)
    const [codBarra, setCodBarra] = useState("")
    const [idCli, setIdCli] = useState(0)

    const [linhaSelecionada, setLinhaSelecionada] = useState<number>(0)
    const [linhasCanceladas, setLinhasCanceladas] = useState<any>([])

    const [visible_Modal_Abrir_Grade_Venda, setVisible_Modal_Abrir_Grade_Venda] = useState(false)
    const [idProd, setIdProd] = useState(0)

    const [idNumItem, setIdNumItem] = useState(0)
    //const [dadosDoDesconto, setDadosDoDesconto] = useState(0)
    //const [dadosDoValorDesconto, setDadosDoValorDesconto] = useState(0)

    let user = useSelector(state => selectUser(state))

    const navigate = useNavigate()

    //--------------------------------------------------------------------------- MODAL ---------------------------------------------------------------------------
    const tirarFocus = () => {

        document.activeElement instanceof HTMLElement && document.activeElement.blur(); // função para tirar o focus do input do codigo de barras
    }

    const abrirBuscarProduto = () => {

        if (loading === false) {

            if (messageType === "DANGER") {
                setVisibleMsg(false)
            }

            tirarFocus()
            setVisibleBuscarProd(true)

            const timer = setTimeout(() => {
                setCodBarra(codBarra.replace(/[^\d*]/g, ''))
                clearTimeout(timer)
            }, 0)
        }
    }

    const abrirModalGrade = useCallback(() => {
        setVisible_Modal_Abrir_Grade_Venda(true)
    }, [])

    const abrirModalDesconto = () => {

        if (messageType === "DANGER") {
            setVisibleMsg(false)
        }

        if (idVenda === 0) {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("É necessário abrir uma venda para aplicar o desconto")
                clearTimeout(timer)
            }, 250)

        } else if (totalItens == 0) {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Não há itens disponíveis para definir o desconto")
                clearTimeout(timer)
            }, 250)

        } else {
            tirarFocus()
            setVisibleDesconto(true)
        }
    }

    const abrirIdentificarCliente = () => {

        if (messageType === "DANGER") {
            setVisibleMsg(false)
        }

        if (loading === false) {

            if (idVenda === 0) {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("É necessário abrir uma venda para identificar o cliente")
                    clearTimeout(timer)
                }, 250)

            } else {

                tirarFocus()
                setVisibleIdentificarCli(true)
            }
        }
    }

    const abrirModalCancelarIdentificacao = () => {

        if (messageType === "DANGER") {
            setVisibleMsg(false)
        }

        if (idVenda > 0 && idCli > 0) {

            tirarFocus()
            setVisibleCancelIdentifcacao(true)

        } else {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("É necessário identificar o cliente antes de cancelar")
                clearTimeout(timer)
            }, 250)

        }
    }

    const abrirModalCancelarVendaItem = () => {

        if (messageType === "DANGER") {
            setVisibleMsg(false)
        }

        if (numItem > 0) {

            tirarFocus()
            setVisibleCancelItemVenda(true)

        } else {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Selecione um item para realizar o cancelamento")
                clearTimeout(timer)
            }, 250)

        }
    }

    const abrirModalCancelarVenda = () => {

        if (messageType === "DANGER") {
            setVisibleMsg(false)
        }

        if (idVenda > 0) {

            tirarFocus()
            setVisibleCancelVenda(true)

        } else {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("É necessário abrir uma venda primeiro")
                clearTimeout(timer)
            }, 250)

        }

    }

    const abrirModalFecharVenda = () => {

        if (messageType === "DANGER") {
            setVisibleMsg(false)
        }

        if (loading === false) {

            if (idVenda > 0) {

                if (visible_Modal_Fechar_Venda === false) {
                    abrirModalDesconto()
                }

            } else {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("É necessário abrir uma venda primeiro")
                    clearTimeout(timer)
                }, 250)

            }
        }
    }

    const abrirModalConfigImpress = () => {

        if (messageType === "DANGER") {
            setVisibleMsg(false)
        }

        if (loading === false) {
            setVisible_Modal_Config_Impressao(true)
        }
    }

    const consultaCodBarraEvent = useCallback(async (codBarraBuscaProd: string) => {
        setVisibleMsg(false)
        setLoading(true)

        try {

            setCodBarra(codBarra.replace(/(\*).*/, "$1") + codBarraBuscaProd)

            if (idVenda === 0) {

                const resp = await VendasService.SaveVenda()

                if (resp.error) {

                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Erro ao abrir a venda")

                } else {

                    setIdVenda(resp.data.id || 0)
                    salvarVendaItemPreenchido(codBarraBuscaProd, resp.data.id, idGrade)
                }

            } else {
                salvarVendaItemPreenchido(codBarraBuscaProd, idVenda, idGrade)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Ocorreu um erro ao selecionar o produto. Por favor, tente novamente")
            setCodBarra("")
            setLoading(false)
        }
    }, [idVenda, idDaVenda, prodVendas, codBarra])

    //------------------------------------------------------------------------------ FUNÇÕES RELACIONADAS AO MODAL BUSCAR PRODUTO E GRADE --------------------------------------------------------------
    const preencherDados = useCallback(async (codBarraBuscaProd: string, idGrade: number) => {

        setVisibleMsg(false)
        setLoading(true)
        setIdGrade(idGrade)

        try {

            setCodBarra(codBarra.replace(/(\*).*/, "$1") + codBarraBuscaProd)

            if (idVenda === 0) {

                const resp = await VendasService.SaveVenda()

                if (resp.error) {

                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Erro ao abrir a venda")

                } else {

                    setIdVenda(resp.data.id || 0)
                    salvarVendaItemPreenchido(codBarraBuscaProd, resp.data.id, idGrade)
                }

            } else {
                salvarVendaItemPreenchido(codBarraBuscaProd, idVenda, idGrade)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Ocorreu um erro ao selecionar o produto. Por favor, tente novamente")
            setCodBarra("")
            setLoading(false)
        }

    }, [idVenda, idDaVenda, prodVendas, codBarra])

    const salvarVendaItemPreenchido = async (codBarraBuscaProd: string, id_venda_preenchido: number, idGrade: number) => {

        setVisibleMsg(false)

        try {

            const numItem = prodVendas.length + 1

            const match = codBarra.match(/^\d+\*/)

            const numero = match ? match[0].slice(0, -1) : ''

            let itens: any = {
                id_venda: id_venda_preenchido,
                cod_barra: codBarraBuscaProd,
                idGrade: idGrade,
                qtde: parseInt(numero) || 1,
            }

            const resp = await VendasService.SaveItemVenda(itens)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")

            } else {

                let itensLista: any = {
                    id_venda: resp.data.venda.id,
                    id_produto: resp.data.v_item.id_produto,
                    desc_prod: resp.data.v_item.desc_prod,
                    cod_barra: codBarraBuscaProd,
                    qtde: parseInt(numero) || 1,
                    vl_unit: resp.data.v_item.vl_unit || 0,
                    vl_tot: resp.data.v_item.vl_tot || 0,
                    numItem: numItem
                }

                setProdVendas([itensLista, ...prodVendas])

                setTotalItens(resp.data.venda.qtd_itens)
                setSubTotal(Funcoes.numberFormat(resp.data.venda.vl_liquido, 'currency'))
                setSubTotalCopy(Funcoes.numberFormat(resp.data.venda.vl_bruto, 'currency'))

                setVisibleBuscarProd(false)
                setVisible_Modal_Abrir_Grade_Venda(false)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao lançar o produto")

        } finally {

            setCodBarra("")
            setLoading(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const fecharModalBuscarProduto = useCallback(() => {
        setVisibleBuscarProd(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)

    }, [])

    const dadosDoProd = useCallback((dadosId: number) => {
        setIdProd(dadosId)
    }, [])

    const fecharModalGrade = useCallback(() => {
        setVisible_Modal_Abrir_Grade_Venda(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            const inputElement = document.getElementById("inputCodBarra")
            inputElement?.focus()
            clearTimeout(timer)
        }, 0)

    }, [])

    //---------------------------------------------------------------------------------- FUNÇÕES RELACIONADAS AO MODAL DESCONTO --------------------------------------------------------------
    const preencherDesconto = useCallback(async (valorDesconto: string, filtro: string) => {

        setVisibleMsg(false)
        setLoadingDesconto(true)

        try {

            if (idVenda > 0) {
                let desconto = parseFloat(valorDesconto)

                if (filtro === 'Porcentagem') {

                    const subTot = parseFloat(subTotalCopy.replace("R$", "").replace(/\./g, "").replace(",", "."))

                    let porcentagemDesconto = Funcoes.numberFormat((subTot * desconto) / 100, 'decimal', 2, 2)

                    const resp = await VendasService.VendaDesconto(idVenda, porcentagemDesconto.replaceAll('.', '').replace(',', '.'))

                    if (resp.error === true) {

                        setVisibleMsg(true)
                        setMessageType("DANGER")
                        setMessage(resp.msg || "")

                    } else {

                        setTotalItens(resp.data.qtd_itens)
                        setSubTotal(Funcoes.numberFormat(resp.data.vl_liquido, 'currency'))
                        setDesconto(Funcoes.numberFormat(resp.data.vl_desc, 'currency'))

                        setVisibleDesconto(false)
                        setVisible_Modal_Fechar_Venda(true)

                    }

                } else {
                    const resp = await VendasService.VendaDesconto(idVenda, desconto)

                    if (resp.error) {

                        setVisibleMsg(true)
                        setMessageType("DANGER")
                        setMessage(resp.msg || "")

                    } else {

                        setTotalItens(resp.data.qtd_itens)
                        setSubTotal(Funcoes.numberFormat(resp.data.vl_liquido, 'currency'))
                        setDesconto(Funcoes.numberFormat(resp.data.vl_desc, 'currency'))

                        setVisibleDesconto(false)
                        setVisible_Modal_Fechar_Venda(true)
                    }
                }
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao preencher o desconto")

            const timer = setTimeout(() => {
                const inputElement = document.getElementById("inputDesconto")
                inputElement?.focus()
                clearTimeout(timer)
            }, 0)

        } finally {

            setLoadingDesconto(false)
        }

    }, [idVenda, idDaVenda, subTotalCopy])

    const fecharModalDesconto = useCallback(() => {

        setVisibleDesconto(false)
        setVisible_Modal_Fechar_Venda(true)
        setVisibleMsg(false)

    }, [])

    //-------------------------------------------------------------------------------- FUNÇÕES RELACIONADAS AO MODAL IDENTIFICAR CLIENTE E CANCELAR IDENTIFICAÇÃO --------------------------------------------------------------
    const identificarConsumidor = useCallback(async (dadosConsumidor: any) => {

        setVisibleMsg(false)
        setLoadingIdentificarCli(true)

        try {

            let itens: any = {
                id_venda: idVenda,
                id_consumidor: dadosConsumidor.id_consumidor,
                nome_consumidor: dadosConsumidor.nome_consumidor,
                doc: dadosConsumidor.doc,
                logradouro: dadosConsumidor.logradouro,
                bairro: dadosConsumidor.bairro,
                numero: dadosConsumidor.numero,
                complemento: dadosConsumidor.complemento,
                uf: dadosConsumidor.uf,
                id_cidade: dadosConsumidor.id_cidade,
                observacao: dadosConsumidor.observacao,
                cep: dadosConsumidor.cep,
                idVendedor: dadosConsumidor.idVendedor,
                nomeVendedor: dadosConsumidor.nomeVendedor
            }

            setDadosCliente(itens)
            setIdCli(dadosConsumidor.id_consumidor)

            const resp = await VendasService.IdentificarConsumidorVenda(itens)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")

            } else {

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage("Sucesso na identificação")

                setVisibleIdentificarCli(false)

                const timer = setTimeout(() => {
                    Inputfocus()
                    clearTimeout(timer)
                }, 0)

            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro na identificação do consumidor")

        } finally {
            setLoadingIdentificarCli(false)
        }

    }, [idVenda, idDaVenda])

    const cancelarIdentificacaoCliente = useCallback(async () => {

        setVisibleMsg(false)
        setLoadingCancelIdentifcacao(true)

        try {

            const resp = await VendasService.CancelarIdentificarConsumidorVenda(idVenda)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")

            } else {

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage("Identificação cancelada com sucesso")

                setVisibleCancelIdentifcacao(false)
                setDadosCliente([])
                setIdCli(0)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao cancelar a identificação do consumidor")

        } finally {
            setLoadingCancelIdentifcacao(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 0)
        }

    }, [idVenda, idDaVenda])

    const fecharModalCancelarIdentificacao = useCallback(() => {

        setVisibleCancelIdentifcacao(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)

    }, [])

    const fecharModalIdentificacaoCliente = useCallback(() => {

        setVisibleIdentificarCli(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)

    }, [])

    //-------------------------------------------------------------------------------- FUNÇÕES RELACIONADAS AO MODAL CANCELAR VENDA E CANCELAR VENDA ITEM --------------------------------------------------------------
    const cancelarVendaItem = useCallback(async () => {

        setVisibleMsg(false)
        setLoadingCancelItemVenda(true)

        try {

            setLinhaSelecionada(0)

            const resp = await VendasService.CancelarVendaItem(idVenda, numItem)

            if (resp.error === true) {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage(resp.msg || "")
                    clearTimeout(timer)
                }, 250)

            } else {

                setLinhasCanceladas((prevLinhas: any) => {
                    if (prevLinhas.includes(numItem)) {
                        // Se já estiver cancelada, remove da lista
                        return prevLinhas.filter((id: any) => id !== numItem)
                    } else {
                        // Caso contrário, adiciona à lista
                        return [...prevLinhas, numItem]
                    }
                })

                setTotalItens(resp.data.qtd_itens)
                setSubTotal(Funcoes.numberFormat(resp.data.vl_liquido, 'currency'))
                setNumItem(0)

                setVisibleCancelItemVenda(false)
            }

            Inputfocus()

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao cancelar o item da venda")

        } finally {
            setLoadingCancelItemVenda(false)
        }

    }, [idVenda, numItem])

    const cancelarVenda = useCallback(async (motivo: string, senha: string) => {

        setLoadingCancelVenda(true)
        setVisibleMsg(false)
        setIdGrade(0)

        try {

            const resp = await VendasService.CancelarVenda(idVenda, senha, motivo)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")

                const timer = setTimeout(() => {
                    const inputElement = document.getElementById("motivo")
                    inputElement?.focus()
                    clearTimeout(timer)
                }, 0)

            } else {

                setProdVendas([])
                setLinhasCanceladas([])
                setLinhaSelecionada(0)
                setIdVenda(0)
                setCodBarra("")
                setTotalItens(0)
                setSubTotal(Funcoes.numberFormat(0, "currency"))
                setNumItem(0)
                setDesconto("")

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage("Venda cancelada com sucesso")

                setVisibleCancelVenda(false)

                const timer = setTimeout(() => {
                    Inputfocus()
                    clearTimeout(timer)
                }, 0)

                if (idDaVenda) {
                    navigate(`/venda`)
                }
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao cancelar a venda")

            const timer = setTimeout(() => {
                const inputElement = document.getElementById("motivo")
                inputElement?.focus()
                clearTimeout(timer)
            }, 0)

        } finally {

            setLoadingCancelVenda(false)
        }

    }, [idVenda, idDaVenda])

    const fecharModalCancelarVendaItem = useCallback(() => {

        setVisibleCancelItemVenda(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)
    }, [])

    const fecharModalCancelarVenda = useCallback(() => {

        if (messageType == 'SUCCESS') {
            setVisibleCancelVenda(false)
        }

        setVisibleMsg(false)

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)
    }, [])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setVisibleCancelVenda(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)
    }, [])

    // --------------------------------------------------------------------------- FUNÇÕES RELACIONADAS AO MODAL CONFIG IMPRESSAO ------------------------------------
    const fecharModalConfigImp = () => {
        // setVisible_Modal_Config_Impressao(false)

        //setVisibleMsg(false)

        //const timer = setTimeout(() => {
        // Inputfocus()
        // clearTimeout(timer)
        //}, 250)
    }

    const salvarConfigImpress = (dadosConfig: any) => {
        //setLoading_Modal_Config_Impressao(true)

        //localStorage.setItem('@ecommerce/ip', dadosConfig[0].ip || "0")
        //localStorage.setItem('@ecommerce/porta', dadosConfig[0].porta || '')
        //localStorage.setItem('@ecommerce/path_impressora', dadosConfig[0].path_impressora || '')

        //setVisible_Modal_Config_Impressao(false)

        //setLoading_Modal_Config_Impressao(false)

    }

    //-------------------------------------------------------------------------------- FUNÇÕES RELACIONADAS AO MODAL FECHAR VENDA --------------------------------------------------------------
    const fecharVenda = useCallback(() => {

        setVisibleMsg(false)

        if (idVenda > 0) {

            setProdVendas([])
            setLinhasCanceladas([])
            setLinhaSelecionada(0)
            setIdVenda(0)
            setCodBarra("")
            setTotalItens(0)
            setSubTotal(Funcoes.numberFormat(0, "currency"))
            setNumItem(0)
            setDesconto("")

            setVisibleMsg(true)
            setMessageType("SUCCESS")
            setMessage("Venda fechada com sucesso")

            if (idDaVenda) {
                navigate(`/venda`)
            }

            setVisible_Modal_Fechar_Venda(false)
            setDadosCliente([])
            setIdCli(0)

        } else {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Venda não encontrada")
                clearTimeout(timer)
            }, 250)
        }

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)

    }, [idVenda, idDaVenda])

    const fecharModalVenda = useCallback(async () => {

        setLoading(true)
        setVisibleMsg(false)

        try {

            const resp = await VendasService.VendaDesconto(idVenda, '0')

            if (!resp.error) {

                setTotalItens(resp.data.qtd_itens)
                setSubTotal(Funcoes.numberFormat(resp.data.vl_liquido, 'currency'))
                setDesconto(Funcoes.numberFormat(resp.data.vl_desc, 'currency'))

            }

            setVisible_Modal_Fechar_Venda(false)

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao preencher o desconto")

        } finally {

            setLoading(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 0)
        }

    }, [idVenda, idDaVenda])

    const dadosIdCliente = useCallback((id: number) => {
        setIdCli(id)
    }, [idVenda, idDaVenda])

    const alterarDadosModalDesconto = useCallback(() => {
        setVisible_Modal_Fechar_Venda(false)
        abrirModalDesconto()
    }, [idVenda, idDaVenda, totalItens])

    const loadingTrue = useCallback(() => {
        setVisibleMsg(false)
        setLoading(true)
    }, [])

    const loadingFalse = useCallback(() => {
        setLoading(false)
    }, [])

    //-------------------------------------------------------------------------------- FUNÇÕES DA TELA DE VENDAS --------------------------------------------------------------
    const codBarraChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCodBarra(e.target.value)
    }

    const salvarVendaItem = async (id: number) => {

        setVisibleMsg(false)

        try {

            if (codBarra !== '') {

                let numItem = 0
                // if (prodVendas.length > 0){
                //     numItem = prodVendas.length + 1                
                // }
                //const numItem = prodVendas.length + 1

                const match = codBarra.match(/^\d+\*/)

                const numero = match ? match[0].slice(0, -1) : ''

                const retornoApi = await ProdutoService.GetGradeProdutoPorCodBarra(codBarra.replace(/^\d+\*/, ""))
                
                const grade: GradeProduto[] = retornoApi.data

                if (retornoApi.error){
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Código de barras não localizado")
                    return
                }
                                
                let itens: ItensVendas = {
                    id_venda: id,
                    cod_barra: codBarra.replace(/^\d+\*/, ""),
                    qtde: parseInt(numero) || 1,
                    idGrade: grade[0]?.id || 0,
                    numItem: numItem,
                    id_produto: retornoApi.id ?? 0,
                    desc_prod: '',
                    vl_unit: 0,
                    vl_tot: 0,
                    referencia: ''
                }

                const resp = await VendasService.SaveItemVenda(itens)

                if (resp.error) {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage(resp.msg ?? "")

                } else {

                    let itensLista: any = {
                        id_venda: id,
                        id_produto: resp.data.v_item.id_produto,
                        desc_prod: resp.data.v_item.desc_prod,
                        cod_barra: codBarra.replace(/^\d+\*/, ""),
                        qtde: parseInt(numero) || 1,
                        vl_unit: resp.data.v_item.vl_unit || 0,
                        vl_tot: resp.data.v_item.vl_tot || 0,
                        numItem: numItem
                    }

                    setProdVendas([itensLista, ...prodVendas])

                    setTotalItens(resp.data.venda.qtd_itens)
                    setSubTotal(Funcoes.numberFormat(resp.data.venda.vl_liquido, 'currency'))
                    setSubTotalCopy(Funcoes.numberFormat(resp.data.venda.vl_bruto, 'currency'))
                }

            } else {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Código de barras não informado..")
                    clearTimeout(timer)
                }, 250)

            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao lançar o produto na venda "+error)

        } finally {

            setLoading(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleClick = (item: any, id: any) => {

        setLinhaSelecionada(id === linhaSelecionada ? null : id)

        if (id === linhaSelecionada) {

            setNumItem(0)

        } else {

            setNumItem((item.numItem || item.nitem))
        }
    }

    useEffect(() => {

        const handleKeyPress = async (event: any) => {

            const modalStates = [
                visibleBuscarProd,
                visibleDesconto,
                visibleCancelItemVenda,
                visibleCancelVenda,
                visibleIdentificarCli,
                visibleCancelIdentifcacao,
                visible_Modal_Fechar_Venda,
                visible_Modal_Edit_Item_Venda,
                loading,
            ]

            if ((event.code === KEY_CODE_ENTER || event.code === "NumpadEnter") && modalStates.every(state => !state)) {

                setLoading(true)

                try {

                    if (idVenda === 0) {

                        setVisibleMsg(false)

                        const resp = await VendasService.SaveVenda()

                        if (resp.error) {

                            const timer = setTimeout(() => {
                                setVisibleMsg(true)
                                setMessageType("DANGER")
                                setMessage(resp.msg || "")
                                clearTimeout(timer)
                            }, 250)

                        } else {

                            setIdVenda(resp.data.id || 0)
                            salvarVendaItem(resp.data.id || 0)
                        }

                    } else {
                        salvarVendaItem(idVenda)
                    }

                    setCodBarra("")

                } catch (error) {

                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Houve um erro ao iniciar a venda")
                    setLoading(false)

                    const timer = setTimeout(() => {
                        Inputfocus()
                        clearTimeout(timer)
                    }, 0)

                }
            }
        }

        const handleKeyPressF4 = (event: any) => {

            if (event.code === "F4") {

                const modalStates = [
                    visibleDesconto,
                    visibleCancelItemVenda,
                    visibleCancelVenda,
                    visibleIdentificarCli,
                    visibleCancelIdentifcacao,
                    visible_Modal_Fechar_Venda,
                    visible_Modal_Config_Impressao,
                    visible_Modal_Edit_Item_Venda
                ]

                if (modalStates.every(state => !state)) {
                    abrirBuscarProduto()
                }
            }
        }

        const handleKeyPressF2 = (event: any) => {

            if (event.code === "F2") {

                const modalStates = [
                    visibleBuscarProd,
                    visibleDesconto,
                    visibleCancelItemVenda,
                    visibleCancelVenda,
                    visibleCancelIdentifcacao,
                    visible_Modal_Fechar_Venda,
                    visible_Modal_Config_Impressao,
                    visible_Modal_Edit_Item_Venda
                ]

                if (modalStates.every(state => !state)) {
                    setVisibleMsg(false)

                    if (idVenda === 0) {
                        const timer = setTimeout(() => {
                            setVisibleMsg(true)
                            setMessageType("DANGER")
                            setMessage("É necessário abrir uma venda para identificar o cliente")
                            clearTimeout(timer)
                        }, 250)
                    } else {
                        abrirIdentificarCliente()
                    }
                }
            }
        }

        const handleKeyPressF8 = (event: any) => {

            if (event.code === "F8") {
                const modalStates = [
                    visibleBuscarProd,
                    visibleDesconto,
                    visibleCancelItemVenda,
                    visibleCancelVenda,
                    visibleIdentificarCli,
                    visibleCancelIdentifcacao,
                    visible_Modal_Config_Impressao,
                    visible_Modal_Edit_Item_Venda,
                ]

                if (modalStates.every(state => !state)) {
                    setVisibleMsg(false)

                    if (idVenda > 0) {
                        abrirModalFecharVenda()
                    } else {
                        const timer = setTimeout(() => {
                            setVisibleMsg(true)
                            setMessageType("DANGER")
                            setMessage("É necessário abrir uma venda primeiro")
                            clearTimeout(timer)
                        }, 250)
                    }
                }
            }
        }

        const handleKeyDown = (event: any) => {

            const modalStates = [
                visibleBuscarProd,
                visibleDesconto,
                visibleCancelItemVenda,
                visibleCancelVenda,
                visibleIdentificarCli,
                visibleCancelIdentifcacao,
                visible_Modal_Fechar_Venda,
                visible_Modal_Edit_Item_Venda
            ]

            if (modalStates.every(state => !state)) {

                const { key } = event

                if (key === 'ArrowUp' || key === 'ArrowDown') {
                    event.preventDefault()

                    let nextIndex

                    if (key === 'ArrowUp') {

                        nextIndex = linhaSelecionada === 0 ? prodVendas.length : linhaSelecionada + 1

                        if (nextIndex > prodVendas.length) {
                            setNumItem(0)
                        } else {
                            setNumItem(nextIndex)
                        }

                    } else {
                        nextIndex = linhaSelecionada === 1 ? 1 : linhaSelecionada === 0 ? prodVendas.length : linhaSelecionada - 1
                        setNumItem(nextIndex)
                    }

                    const element = document.getElementById(`produto-lancado-${(prodVendas.length + 1) - nextIndex}`)
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        })
                    }

                    setLinhaSelecionada(Math.max(0, Math.min(nextIndex, prodVendas.length)))

                }
            }

        }

        const handleMouseUp = (event: any) => {

            const modalStates = [
                visibleBuscarProd,
                visibleDesconto,
                visibleCancelItemVenda,
                visibleCancelVenda,
                visibleIdentificarCli,
                visibleCancelIdentifcacao,
                visible_Modal_Fechar_Venda,
                visible_Modal_Config_Impressao,
                visible_Modal_Edit_Item_Venda
            ]

            if ((event.button === 0 || event.button === 1 || event.button === 2) && modalStates.every(state => !state)) {
                Inputfocus()
            }
        }

        document.addEventListener('keydown', handleKeyPress)
        document.addEventListener('keydown', handleKeyPressF4)
        document.addEventListener('keydown', handleKeyPressF2)
        document.addEventListener('keydown', handleKeyPressF8)
        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('mouseup', handleMouseUp)

        return () => {
            document.removeEventListener('keydown', handleKeyPress)
            document.removeEventListener('keydown', handleKeyPressF4)
            document.removeEventListener('keydown', handleKeyPressF2)
            document.removeEventListener('keydown', handleKeyPressF8)
            document.removeEventListener('keydown', handleKeyDown)
            document.removeEventListener('mouseup', handleMouseUp)
        }

    }, [idVenda, idDaVenda, loading, codBarra, linhaSelecionada, prodVendas.length, visibleBuscarProd, visibleDesconto, visibleCancelItemVenda, visibleCancelVenda, visibleIdentificarCli, visibleCancelIdentifcacao, visible_Modal_Fechar_Venda, visible_Modal_Config_Impressao, visible_Modal_Edit_Item_Venda])

    useEffect(() => {
        getAttributes()
    }, [])

    const getAttributes = async () => {
        setLoading(true)

        try {

            if (idDaVenda && parseInt(idDaVenda) > 0) {

                const relatorio = {
                    id_venda: idDaVenda,
                }

                const attr = await VendasService.ConsultarVendas(relatorio)
                console.log("attr: ", attr)

                if (attr) {
                    setProdVendas((prev) => [...(attr.data[0]?.itens || [])].reverse());
                    setIdVenda(attr.data[0]?.id || 0)
                    setTotalItens(attr.data[0]?.qtd_itens || 0)
                    setSubTotal(attr.data[0]?.vl_liquido ? Funcoes.numberFormat(attr.data[0].vl_liquido, 'currency') : Funcoes.numberFormat(0, "currency"))
                }
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao retornar os dados da venda")

        } finally {
            setLoading(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 250)
        }

    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("cod_barra")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
        //Inputfocus()
    }

    // ---------------------------------------------------------------- USEEFFECT DE ALTURA --------------------------------------------------------------
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerHeight <= 600)

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerHeight <= 600)
        }

        window.addEventListener('resize', handleResize)

        // Limpeza do event listener ao desmontar o componente
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    //----------------------------------------------------------------- EDIÇÃO DE ITEM DA VENDA --------------------------------------------------------------------------------------//
    const abrirModalEditarItemVenda = (item: any) => {
        setIdNumItem(item)
        setVisible_Modal_Edit_Item_Venda(true)
    }

    const fecharModalEditarItemVenda = useCallback(() => {
        setVisible_Modal_Edit_Item_Venda(false)
        Inputfocus()
    }, [])

    const updateDadosVendas = useCallback((novoItem: any) => {
        setProdVendas(prevItens => {
            const chaveNovo = novoItem.numItem;

            const novaLista = prevItens.map(item => {
                const chaveItem = item.numItem ?? item.nitem;
                return chaveItem === chaveNovo ? novoItem : item;
            });

            return novaLista;
        });

        setTotalItens(novoItem.totalItems)
        setSubTotal(Funcoes.numberFormat(novoItem.subTotal, 'currency'))
        setSubTotalCopy(Funcoes.numberFormat(novoItem.subTotalCopy, 'currency'))

        setVisible_Modal_Edit_Item_Venda(false)
        Inputfocus()
    }, [])

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} flex flex-row`}>

                        <div className={`flex items-center w-auto`}>
                            <IoCreate className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Vendas</span>
                        </div>

                        <div className={`flex justify-end items-center w-full text-slate-700 dark:text-slate-200`}>

                            <span className={`text-[15px] mx-4 font-semibold`}>
                                ( F2 ) Identificar Cliente
                            </span>

                            <span className={`text-[15px] mx-4 font-semibold`}>
                                ( F4 ) Procurar Produto
                            </span>

                            <span className={`text-[15px] mx-4 font-semibold`}>
                                ( F8 ) Fechar a venda
                            </span>

                        </div>

                    </div>

                    <div className={`bg-white dark:bg-slate-600 py-4 mt-2 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 rounded-md cursor-default flex flex-row items-center`}>

                        <div className={`relative w-[80%] pl-4`}>

                            { /* recurso utilizado para o navegador não jogar o email do usuário nesse campo */ }
                            <input
                                type="text"
                                name="fake_autofill_field"
                                style={{ display: 'none' }}
                                autoComplete="username"
                            />

                            <input id="cod_barra" className={`${classInput} ${classInputDark} text-[18px]`} type="text" placeholder='3*00000000' autoComplete="off" value={codBarra} onChange={codBarraChange} disabled={loading} />
                            <label htmlFor="cod_barra" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ml-4`}>Código de barras </label>
                        </div>

                        <div className={`relative w-[20%] ml-4 pr-4`}>
                            <input id="num_itens" className={`${classInput} ${classInputDark} text-[18px] cursor-not-allowed disabled:opacity-100 text-end`} type="text" placeholder=' ' autoComplete="off" value={totalItens} disabled={true} />
                            <label htmlFor="num_itens" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Total itens</label>
                        </div>

                    </div>

                    <div className={`flex flex-row`}>

                        <div className={`w-full ${isSmallScreen ? '' : 'xl:w-[80%] pr-2'} flex flex-col`}>

                            <div className={`w-full`}>

                                <div className={`bg-white dark:bg-slate-600 border border-b-0 dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 px-1 pt-1 mt-2 ${prodVendas.length >= 7 && isSmallScreen ? `pr-4` : prodVendas.length >= 18 ? `pr-4` : ``}  rounded-t-md`}>

                                    <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-white `}>

                                        <li className={`h-full border border-white dark:border-slate-600`}>

                                            <div className={`w-full flex flex-row h-10 `}>

                                                <div className={`flex items-center w-[7%] xl:w-[5%] h-full text-sm xl:text-base border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Item</span>
                                                </div>

                                                <div className={`flex items-center w-[43%] xl:w-[45%] h-full text-sm xl:text-base border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Descrição</span>
                                                </div>

                                                <div className={`flex items-center justify-end w-[10%] h-full text-sm xl:text-base border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Qtd.</span>
                                                </div>

                                                <div className={`flex items-center justify-end w-[15%] h-full text-sm xl:text-base border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Unit.</span>
                                                </div>

                                                <div className={`flex items-center justify-end w-[15%] h-full text-sm xl:text-base border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Total</span>
                                                </div>

                                                <div className={`flex items-center justify-center w-[10%] h-full text-sm xl:text-base border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Ações</span>
                                                </div>

                                            </div>

                                        </li>

                                    </ul>

                                </div>

                            </div>

                            <div className={`${isSmallScreen ? 'h-[250px]' : 'h-[600px]'} bg-white dark:bg-slate-600 px-1 border border-t-0 dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 rounded-b-md overflow-auto scrollbar-track-transparent scrollbar-thumb-slate-400 dark:scrollbar-thumb-slate-800 scrollbar-thin dark:scrollbar-thin cursor-default`}>

                                <ul className={`w-full h-full bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                    {prodVendas.length > 0 &&

                                        prodVendas.map((item, index) => {

                                            const isCancelled = linhasCanceladas.includes((item.numItem || item.nitem))

                                            return (

                                                <li key={item.numItem || item.nitem} tabIndex={0} id={`produto-lancado-${(prodVendas.length + 1) - (item.numItem || item.nitem)}`} onClick={() => handleClick(item, (item.numItem || item.nitem))} className={`w-full h-auto duration-150 transition-all focus:outline-none border-2 ${(item.numItem || item.nitem) === linhaSelecionada && isCancelled ? 'border-red-600 dark:border-red-300' : (item.numItem || item.nitem) === linhaSelecionada ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} ${isCancelled ? ' bg-red-500 dark:bg-red-500  text-white ' : 'hover:bg-slate-200 dark:hover:bg-slate-500 '} cursor-pointer`}>

                                                    <div className={`w-full flex flex-row h-[40px] `}>

                                                        <div className={`flex items-center w-[7%] xl:w-[5%] break-all  border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.numItem || item.nitem}</span>
                                                        </div>

                                                        <div className={`flex items-center w-[43%] xl:w-[45%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <div className={`flex flex-col`}>
                                                                <span className={`px-2`}>{item.desc_prod}</span>
                                                                <span className={`px-2 text-[12px] opacity-80`}>Obs: {item.observacao}</span>
                                                            </div>
                                                        </div>

                                                        <div className={`flex items-center justify-end w-[10%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{Funcoes.numberFormat(item.qtde, 'decimal')}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-end w-[15%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{Funcoes.numberFormat(item.vl_unit, 'currency')}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-end w-[15%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{Funcoes.numberFormat(item.vl_tot, 'currency')}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-center w-[10%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <button
                                                                onClick={() => abrirModalEditarItemVenda(item.numItem || item.nitem)} data-tooltip-id={'tooltip-editar-' + item.numItem} id={'btn-editar-' + item.numItem}
                                                                disabled={isCancelled}
                                                                className={`flex items-center justify-center 
                                                                            text-white transition-all duration-300 
                                                                            hover:bg-sky-600 w-[25px] h-[25px] rounded-md 
                                                                            bg-sky-500 disabled:cursor-not-allowed`}>
                                                                <RiEdit2Fill size="15px" />
                                                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + item.numItem} anchorSelect={'#btn-editar-' + item.numItem} positionStrategy="fixed" place='bottom'  >
                                                                    <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                                                                </Tooltip>
                                                            </button>
                                                        </div>

                                                    </div>

                                                </li>
                                            )
                                        })
                                    }

                                </ul>

                            </div>

                        </div>

                        <div className={`${isSmallScreen ? 'hidden' : 'xl:block xl:w-[20%]'} bg-white dark:bg-slate-600 mt-2 pt-4 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 rounded-md cursor-default`}>

                            <div className={`relative p-2`}>
                                <input id="subTotal" className={`${classInput} ${classInputDark} h-[90px] text-[25px] xl:text-[35px] cursor-not-allowed disabled:opacity-100 text-end`} type="text" placeholder=' ' value={subTotal} autoComplete="off" disabled={true} />
                                <label htmlFor="subTotal" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>SubTotal</label>
                            </div>

                            {/*
                              <div className={`relative p-2`}>
                                <input id="desconto" className={`${classInput} ${classInputDark} h-[60px] text-[20px] cursor-not-allowed`} type="text" placeholder=' ' value={desconto} autoComplete="off" disabled={true} />
                                <label htmlFor="desconto" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>Desconto</label>
                            </div>
                            */}

                            <div className={`p-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul} text-[13px]`} onClick={abrirBuscarProduto} data-tooltip-id={'tooltip-btn-buscarProd'} id={'btn-buscarProd'}>

                                    <LuPackageSearch size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        PROCURAR PRODUTO
                                    </span>

                                </button>
                            </div>

                            {/*
                            <div className={`p-2`}>
                                <button  tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} onClick={abrirModalDesconto} data-tooltip-id={'tooltip-btn-desconto'} id={'btn-desconto'}>

                                    <BiSolidDiscount size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        DESCONTO
                                    </span>

                                </button>
                            </div>
                            */}

                            <div className={`p-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} onClick={abrirIdentificarCliente} data-tooltip-id={'tooltip-btn-identCli'} id={'btn-identCli'}>

                                    <MdPersonSearch size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        IDENTIFICAR CLIENTE / VENDEDOR
                                    </span>

                                </button>
                            </div>

                            <div className={`p-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px] `} onClick={abrirModalCancelarIdentificacao} data-tooltip-id={'tooltip-btn-cancelIdentCli'} id={'btn-cancelIdentCli'}>

                                    <MdOutlinePersonOff size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        CANCELAR IDENTIFICAÇÃO
                                    </span>

                                </button>
                            </div>

                            <div className={`p-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} onClick={abrirModalCancelarVendaItem} data-tooltip-id={'tooltip-btn-cancelItemVenda'} id={'btn-cancelItemVenda'}>

                                    <TbPackageOff size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        CANCELAR ITEM DA VENDA
                                    </span>

                                </button>
                            </div>

                            <div className={`p-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} onClick={abrirModalCancelarVenda} data-tooltip-id={'tooltip-btn-cancelVenda'} id={'btn-cancelVenda'}>

                                    <TbShoppingCartOff size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        CANCELAR VENDA
                                    </span>

                                </button>
                            </div>

                            {/*
                            <div className={`p-2`}>
                                <button  tabIndex={-1} className={`${classbtColunasAzul} text-[13px]`} onClick={abrirModalConfigImpress} data-tooltip-id={'tooltip-btn-congif'} id={'btn-congif'}>

                                    <MdSettings size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        CONFIGURAÇÕES
                                    </span>

                                </button>
                            </div>
                            */}

                            <div className={`p-2`} onClick={abrirModalFecharVenda} data-tooltip-id={'tooltip-btn-fecharVenda'} id={'btn-fecharVenda'}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} >

                                    <MdPointOfSale size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        FECHAR VENDA
                                    </span>

                                </button>
                            </div>

                        </div>

                    </div>

                    <div className={`${isSmallScreen ? '' : 'hidden'} h-[80px] dark:text-white bg-white dark:bg-slate-600 mt-2 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 rounded-md cursor-default flex items-center`}>

                        <div className={`w-full grid grid-cols-12 gap-2 px-2`}>

                            <div className={`relative col-span-1`}>

                                <button tabIndex={-1} className={`${classbtColunasAzul} text-[13px]`} onClick={abrirBuscarProduto} data-tooltip-id={'tooltip-btn-buscarProd'} id={'btn-buscarProd'}>

                                    <LuPackageSearch size={"22px"} className={`flex justify-start w-full`} />

                                    <span className={`w-[90%] hidden`}>
                                        PROCURAR PRODUTO
                                    </span>

                                    {isSmallScreen &&
                                        <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-buscarProd'} anchorSelect={'#btn-buscarProd'} positionStrategy="fixed" place='top-start' >
                                            <span>PROCURAR PRODUTO</span>
                                        </Tooltip>
                                    }
                                </button>

                            </div>

                            {/*
                            <div className={`relative col-span-1`}>
                                <button  tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} onClick={abrirModalDesconto} data-tooltip-id={'tooltip-btn-desconto'} id={'btn-desconto'}>

                                    <BiSolidDiscount size={"22px"} className='flex justify-start w-full' />

                                    <span className='w-[90%] hidden'>
                                        DESCONTO
                                    </span>

                                    {isSmallScreen &&
                                        <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-desconto'} anchorSelect={'#btn-desconto'} positionStrategy="fixed" place='top' >
                                            <span> DESCONTO</span>
                                        </Tooltip>
                                    }
                                </button>
                            </div>
                            */}

                            <div className={`relative col-span-1`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul} text-[13px]`} onClick={abrirIdentificarCliente} data-tooltip-id={'tooltip-btn-identCli'} id={'btn-identCli'}>

                                    <MdPersonSearch size={"22px"} className={`flex justify-start w-full`} />

                                    <span className={`w-[90%] hidden`}>
                                        IDENTIFICAR CLIENTE / VENDEDOR
                                    </span>

                                    {isSmallScreen &&
                                        <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-identCli'} anchorSelect={'#btn-identCli'} positionStrategy="fixed" place='top' >
                                            <span>IDENTIFICAR CLIENTE / VENDEDOR</span>
                                        </Tooltip>
                                    }

                                </button>
                            </div>

                            <div className={`relative col-span-1`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px] `} onClick={abrirModalCancelarIdentificacao} data-tooltip-id={'tooltip-btn-cancelIdentCli'} id={'btn-cancelIdentCli'}>

                                    <MdOutlinePersonOff size={"22px"} className={`flex justify-start w-full`} />

                                    <span className={`w-[90%] hidden`}>
                                        CANCELAR IDENTIFICAÇÃO
                                    </span>

                                    {isSmallScreen &&
                                        <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-cancelIdentCli'} anchorSelect={'#btn-cancelIdentCli'} positionStrategy="fixed" place='top' >
                                            <span>CANCELAR IDENTIFICAÇÃO</span>
                                        </Tooltip>
                                    }

                                </button>
                            </div>

                            <div className={`relative col-span-1`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} onClick={abrirModalCancelarVendaItem} data-tooltip-id={'tooltip-btn-cancelItemVenda'} id={'btn-cancelItemVenda'}>

                                    <TbPackageOff size={"22px"} className={`flex justify-start w-full`} />

                                    <span className={`w-[90%] hidden`}>
                                        CANCELAR ITEM DA VENDA
                                    </span>

                                    {isSmallScreen &&
                                        <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-cancelItemVenda'} anchorSelect={'#btn-cancelItemVenda'} positionStrategy="fixed" place='top' >
                                            <span>CANCELAR ITEM DA VENDA</span>
                                        </Tooltip>
                                    }

                                </button>
                            </div>

                            <div className={`relative col-span-1`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul} text-[13px]`} onClick={abrirModalCancelarVenda} data-tooltip-id={'tooltip-btn-cancelVenda'} id={'btn-cancelVenda'}>

                                    <TbShoppingCartOff size={"22px"} className={`flex justify-start w-full`} />

                                    <span className={`w-[90%] hidden`}>
                                        CANCELAR VENDA
                                    </span>

                                    {isSmallScreen &&
                                        <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-cancelVenda'} anchorSelect={'#btn-cancelVenda'} positionStrategy="fixed" place='top' >
                                            <span>CANCELAR VENDA</span>
                                        </Tooltip>
                                    }

                                </button>
                            </div>

                            <div className={`relative col-span-1`}>

                                <button tabIndex={-1} className={`${classbtColunasAzul} text-[13px]`} onClick={abrirModalFecharVenda} data-tooltip-id={'tooltip-btn-fecharVenda'} id={'btn-fecharVenda'} >

                                    <MdPointOfSale size={"22px"} className={`flex justify-start w-full`} />

                                    <span className={`w-[90%] hidden`}>
                                        FECHAR VENDA
                                    </span>

                                    {isSmallScreen &&
                                        <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-fecharVenda'} anchorSelect={'#btn-fecharVenda'} positionStrategy="fixed" place='top-end' >
                                            <span> FECHAR VENDA</span>
                                        </Tooltip>
                                    }

                                </button>
                            </div>

                            <div className={`relative col-span-6`}>
                                <input id="subTotalVenda" className={`${classInput} ${classInputDark} w-full h-[45px] text-[25px] xl:text-[35px] cursor-not-allowed text-end`} type="text" placeholder=' ' value={subTotal} autoComplete="off" disabled={true} />
                                <label htmlFor="subTotalVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>SubTotal</label>
                            </div>

                            {/*
                            <div className={`relative col-span-2`}>
                                <input id="desconto" className={`${classInput} ${classInputDark} w-full h-[45px] text-[20px] cursor-not-allowed`} type="text" placeholder=' ' value={desconto} autoComplete="off" disabled={true} />
                                <label htmlFor="desconto" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Desconto</label>
                            </div>
                            */}

                        </div>

                    </div>

                    <ModalEditItemVenda
                        visible={visible_Modal_Edit_Item_Venda}
                        id_Venda={idVenda}
                        numItem={idNumItem}
                        atualizarDadosItem={updateDadosVendas}
                        closeModalEvent={fecharModalEditarItemVenda}
                    />

                    <ModalBuscaProduto
                        visible={visibleBuscarProd}
                        visible_Modal_Abrir_Grade_Venda={visible_Modal_Abrir_Grade_Venda}
                        loading={loading}
                        stringDesc={codBarra.replace(/^\d+\*/, "")}
                        onVisibleOpen={abrirModalGrade}
                        onDadosId={dadosDoProd}
                        consultarCodBarraEvent={consultaCodBarraEvent}
                        closeModalEvent={fecharModalBuscarProduto}
                    />

                    <ModalAbrirGradeVenda
                        visible={visible_Modal_Abrir_Grade_Venda}
                        loading={loading}
                        idProd={idProd}
                        lancarCodBarras={preencherDados}
                        closeModalEvent={fecharModalGrade}
                    />

                    <ModalDesconto
                        visible={visibleDesconto}
                        loading={loadingDesconto}
                        lancarDescontoEvent={preencherDesconto}
                        closeModalEvent={fecharModalDesconto}
                    />

                    <ModalIdentificarCliente
                        visible={visibleIdentificarCli}
                        loading={loadingIdentifcarCli}
                        idVenda={idVenda.toString()}
                        identificarConsumidorEvent={identificarConsumidor}
                        closeModalEvent={fecharModalIdentificacaoCliente}
                    />

                    <ModalCancelarIdentificacao
                        visible={visibleCancelIdentifcacao}
                        loading={loadingCancelIdentifcacao}
                        buttonConfirmClick={cancelarIdentificacaoCliente}
                        closeModalEvent={fecharModalCancelarIdentificacao}
                    />

                    <ModalCancelVendaItem
                        visible={visibleCancelItemVenda}
                        loading={loadingCancelItemVenda}
                        buttonConfirmClick={cancelarVendaItem}
                        closeModalEvent={fecharModalCancelarVendaItem}
                    />

                    <ModalExcluirDados
                        show={visibleCancelVenda}
                        isLoading={loadingCancelVenda}
                        message='Deseja cancelar esta venda?'
                        alertType={messageType}
                        feedBackVisible={visibleMsg}
                        messageFeedBack={message}
                        cancelarVenda={true}
                        closeModalEvent={fecharModalCancelarVenda}
                        excluirEvent={cancelarVenda}
                        fecharModalEvent={buttonFecharModalExcluirDados}

                    />

                    {/*
                    <ModalConfiImpress
                        visible={visible_Modal_Config_Impressao}
                        loading={loading_Modal_Config_Impressao}
                        salvarConfigEvent={salvarConfigImpress}
                        closeModalEvent={fecharModalConfigImp}
                    />
                    */}

                    <ModalFecharVenda
                        visible={visible_Modal_Fechar_Venda}
                        id_Venda={idVenda}
                        valor_venda={subTotal}
                        dadosVenda={prodVendas || []}
                        dadosCliente={dadosCliente || undefined}
                        dadosDesconto={desconto || "0"}
                        idCliente={idCli}
                        loadingTrue={loadingTrue}
                        loadingFalse={loadingFalse}
                        setIdCliente={dadosIdCliente}
                        fecharVendaEvent={fecharVenda}
                        closeModalEvent={fecharModalVenda}
                        alterarDescontoModalEvent={alterarDadosModalDesconto}
                    />

                </div>

            </div>

        </Template>
    )
})